module.exports = function getResource(label, vars = []) {
    const resources = {
        paymentErrorTitle: 'Error',
        paymentCancellation: 'Unable to place your order. Trouble connecting to PayPal. Please use a different payment method or try again later.<br /><br />If applicable, we have reversed any pending charges to your account.',
        paymentErrorMessage: 'Trouble connecting to PayPal. Please use a different payment method or try again later.',
        authorizationErrorMessage: 'We\'re sorry we cannot authorize your PayPal payment. Please select a different payment method. If applicable we have reversed any pending charges to your account.',
        okButton: 'OK'
    };

    return resources[label];
};
